import { Step } from 'react-joyride';

export const reportsTourSteps: Step[] = [
  {
    target: '[data-tour="reports-header"]',
    content: (
      <div>
        <h4>Reports & Analytics</h4>
        <p>
          Get insights into your team's performance, customer interactions, and service quality
          through comprehensive analytics.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="date-range-picker"]',
    content: (
      <div>
        <h4>Date Range Selection</h4>
        <p>
          Select custom date ranges to analyze data for specific periods. Compare performance across
          different timeframes.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="edit-mode-toggle"]',
    content: (
      <div>
        <h4>Edit Mode</h4>
        <p>
          Toggle edit mode to customize your analytics dashboard. Rearrange widgets and choose which
          metrics to display.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="analytics-charts"]',
    content: (
      <div>
        <h4>Analytics Visualizations</h4>
        <p>
          Interactive charts and graphs display your data visually. Hover over elements for detailed
          information.
        </p>
      </div>
    ),
    placement: 'top'
  }
];
